<div class="align-right">
  <button mat-button color="primary" (click)="addRoundOfQuestions()">
    <mat-icon>add_circle_outline</mat-icon>
    <span> add </span>
  </button>
</div>
<div class="table-container">
  <table mat-table [dataSource]="roundOfQuestions" matSort>

    <ng-container matColumnDef="year">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"kf-reporting.year" |translate}}</th>
      <td mat-cell *matCellDef="let roq">{{roq.year}}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"admin.countries.name" |translate}}</th>
      <td mat-cell *matCellDef="let roq">{{roq.name}}</td>
    </ng-container>

    <ng-container matColumnDef="launched">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"kf-reporting.launched" |translate}}</th>
      <td mat-cell *matCellDef="let roq">{{roq.launched === null ? 'Draft' : datePipe.transform(roq.launched, 'yyyy-MM-dd HH:mm:ss')}}</td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let roq">
        <mat-icon (click)="editRoundOfQuestions(roq)" color="primary"
                  matTooltip="Edit" matTooltipPosition="above">edit
        </mat-icon>
        <mat-icon (click)="addRoundOfQuestions(true, roq)" color="primary"
                  matTooltip="Copy" matTooltipPosition="above">file_copy
        </mat-icon>
        <mat-icon *ngIf="roq.launched" (click)="router.navigateByUrl(router.url + '/' + roq.id + '/' + roq.year + '/preview')" color="primary"
                  matTooltip="Preview" matTooltipPosition="above">view_list
        </mat-icon>
        <mat-icon *ngIf="roq.status === 'ACTIVE'" color="primary"
                  matTooltip="Disable" matTooltipPosition="above"
                  (click)="updateRoundOfQuestions(roq)">check_circle
        </mat-icon>
        <mat-icon *ngIf="roq.status === 'INACTIVE'"
                  color="primary" matTooltip="Enable" matTooltipPosition="above"
                  (click)="updateRoundOfQuestions(roq)">radio_button_unchecked
        </mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator color="primary" [length]="totalElements"
                 [pageSize]="pageSize"
                 (page)="onPageChange($event)"
                 [pageSizeOptions]="pageSizes">
  </mat-paginator>
</div>
